/**
 * new-hero-slider.js
 *
 * Bridges "new-hero-slider" to the "hero-slider" registration,
 * then patches autoplay speed after Flickity initialises.
 */
(function () {
  var NEW_TYPE = 'new-hero-slider';
  var ORIGINAL_TYPE = 'hero-slider';
  var MAX_WAIT_MS = 8000;
  var POLL_INTERVAL_MS = 50;
  var elapsed = 0;

  function tryRegister() {
    var sections =
      window.Shopify &&
      window.Shopify.theme &&
      window.Shopify.theme.sections;

    if (!sections) return false;

    var registered = sections.registered || {};
    if (registered[NEW_TYPE]) return true;
    if (!registered[ORIGINAL_TYPE]) return false;

    // Copy registration under new type name
    registered[NEW_TYPE] = registered[ORIGINAL_TYPE];

    // Fire section load for each new-hero-slider in the DOM
    document
      .querySelectorAll('[data-section-type="' + NEW_TYPE + '"]')
      .forEach(function (el) {
        el.dispatchEvent(
          new CustomEvent('shopify:section:load', {
            bubbles: true,
            detail: { sectionId: el.dataset.sectionId }
          })
        );

        // Patch autoplay speed after Flickity has had time to initialise
        var settings = JSON.parse(el.dataset.sectionSettings || '{}');
        if (settings.autoplay && settings.autoplay_speed) {
          setTimeout(function () {
            patchAutoplaySpeed(el, settings.autoplay_speed * 1000);
          }, 500);
        }
      });

    return true;
  }

  function patchAutoplaySpeed(container, speedMs) {
    // Find the Flickity instance on the slider container element
    var sliderEl = container.querySelector('[data-slider-container]');
    if (!sliderEl) return;

    // Flickity stores its instance on the element
    var flickity = sliderEl._flickity || (window.Flickity && window.Flickity.data && window.Flickity.data(sliderEl));
    if (!flickity) {
      // Try again a bit later — Flickity may not be ready yet
      setTimeout(function () { patchAutoplaySpeed(container, speedMs); }, 300);
      return;
    }

    // Update the autoplay timing
    if (flickity.options) {
      flickity.options.autoPlay = speedMs;
    }
    if (flickity.player) {
      flickity.player.options = flickity.player.options || {};
      flickity.player.options.autoPlay = speedMs;
      // Restart the player with the new timing
      flickity.player.stop();
      flickity.player.play();
    }
  }

  function poll() {
    if (tryRegister()) return;
    elapsed += POLL_INTERVAL_MS;
    if (elapsed >= MAX_WAIT_MS) {
      console.warn('[new-hero-slider] Timed out waiting for hero-slider registration.');
      return;
    }
    setTimeout(poll, POLL_INTERVAL_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', poll);
  } else {
    poll();
  }
})();
